module.exports = __webpack_public_path__ + "static/media/1.d2e99158.jpg";